import React, { useState } from "react";
import { styled } from '@mui/system'
import useStyles from "../styles/dashboard";
import { Grid } from "@mui/material";
import AppBar from "../components/AppBar";

interface Props {
    lunchSomethingWrong: () => void
    lunchSomethingWrong2: () => void
    lunchSomethingWrong3: () => void
    lunchSomethingWrong5: () => void
    handleLimitTransactionOpen: () => void
    handleChangePinOpen: () => void
    handleResetPinOpen: () => void
}

const SettingAccountManagement: React.FC<Props>=({ lunchSomethingWrong, lunchSomethingWrong2, lunchSomethingWrong3, lunchSomethingWrong5, handleLimitTransactionOpen, handleChangePinOpen, handleResetPinOpen })=>{
    const Main = styled('main')(({ theme }) => ({ }));

    const toggleEmailNotification =()=>{
        document.getElementById('toggleEmailNotification')?.classList.toggle('sliderUnchecked')
        
        lunchSomethingWrong()
    }
    const toggleEmailNotification2 =()=>{
        document.getElementById('toggleEmailNotification2')?.classList.toggle('sliderUnchecked')

        lunchSomethingWrong2()
    }
    const toggleEmailNotification3 =()=>{
        document.getElementById('toggleEmailNotification3')?.classList.toggle('sliderUnchecked')

        lunchSomethingWrong3()
    }

 
    
    return (
        <Main id="content">
            <AppBar />

            <section className="container">

                <ul className="ben-page-nav ben-page-nav-tabs" id="PageNavigator">
                    <li className="ben-page-nav-item">
                        <a className="ben-page-nav-link active">Profile</a>
                    </li>
                </ul>


                <div className="ben-groom-panel">
                    <div style={{paddingTop: '1.5rem'}}>


                        <ul className="setting-nav setting-nav-tabs" id="setting-setTab" role="tablist">
                            <li className="setting-nav-item">
                                <a className="setting-nav-link" href="/settings/profile"><span className="setting-user-icon"></span>Profile</a>
                            </li>
                            <li className="setting-nav-item">
                                <a className="setting-nav-link active" href="/settings/account-management"><span className="setting-credit-icon"></span>Account Management</a>
                            </li>
                            <li className="setting-nav-item">
                                <a className="setting-nav-link" href="/settings/legal"><span className="setting-smartshield"></span>Legal</a>
                            </li>
                            <li className="setting-nav-item">
                                <a className="setting-nav-link" href="/settings/help"><span className="setting-bigedit"></span>Help &amp; Support</a>
                            </li>
                        </ul>
                    </div>





                    <Grid container style={{justifyContent: 'center'}}>
                        <Grid item style={{padding: '0 15px'}} xs={12} lg={8.5}>
                            <div style={{padding: '0 1rem'}}>


                                <div className="accountSetting" style={{marginBottom: '2rem'}} onClick={handleLimitTransactionOpen}>
                                    <h6 className="label--heading">Spend Limit</h6>

                                    <h5 className="mb-0 label--heading--h5--accountSetting" onClick={handleLimitTransactionOpen}>
                                        <label className="label--text label--text-after" style={{cursor: 'pointer', transition: 'all 0.3s linear'}}>Transfers</label>
                                        <div className="bus-down"></div>
                                    </h5>

                                </div>



                                {/* Notifications */}


                                <div className="accountSetting" style={{marginTop: '1rem'}}>
                                    <h6 className="label--heading">Notifications</h6>
                                    
                                    <Grid container>
                                        <Grid item xs={6}>
                                            <label className="label--text">Email notifications</label>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <div className="customSwitch float-right" onClick={toggleEmailNotification}>
                                                <input name="emailEnabled" type="checkbox" checked />
                                                <span id="toggleEmailNotification" className="slider round"></span>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>



                                <div className="accountSetting">
                                    <Grid container>
                                        <Grid item xs={6}>
                                            <label className="label--text">Push notifications</label>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <div className="customSwitch float-right" onClick={toggleEmailNotification2}>
                                                <input name="emailEnabled" type="checkbox" checked />
                                                <span id="toggleEmailNotification2" className="slider round"></span>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>


                                <div className="accountSetting" style={{marginBottom: '2rem'}}>
                                    <Grid container>
                                        <Grid item xs={6}>
                                            <label className="label--text">SMS <span style={{fontWeight: '500'}}>(attracts extra charges)</span></label>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <div className="customSwitch float-right" onClick={toggleEmailNotification3}>
                                                <input name="emailEnabled" type="checkbox" checked />
                                                <span id="toggleEmailNotification3" className="slider round"></span>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>


                                {/* Securyty */}


                                <div className="accountSetting" style={{marginTop: '1rem'}}>
                                    <h6 className="label--heading">Security</h6>
                                    <h5 className="mb-0 label--heading--h5--accountSetting" onClick={handleChangePinOpen}>
                                        <label className="label--text label--text-after" style={{cursor: 'pointer', transition: 'all 0.3s linear'}}>Change Transaction Pin</label>
                                        <div className="bus-down"></div>
                                    </h5>
                                </div>


                                <div className="accountSetting">
                                    <h5 className="mb-0 label--heading--h5--accountSetting" onClick={lunchSomethingWrong5}>
                                        <label className="label--text label--text-after" style={{cursor: 'pointer', transition: 'all 0.3s linear'}}>Reset Transaction Pin</label>
                                        <div className="bus-down"></div>
                                    </h5>
                                </div>


                                <div className="accountSetting" style={{marginBottom: '2rem'}}>
                                    <h5 className="mb-0 label--heading--h5--accountSetting" onClick={lunchSomethingWrong5}>
                                        <label className="label--text label--text-after" style={{cursor: 'pointer', transition: 'all 0.3s linear'}}>Request New Login ID</label>
                                        <div className="bus-down"></div>
                                    </h5>
                                </div>


                            </div>
                        </Grid>
                    </Grid>
                </div>

            </section>

        </Main>
    )
}

export default SettingAccountManagement